import { takeEvery, all } from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';

import {
  createUserSaga,
  signInWithEmailSaga,
  signInWithTokenSaga,
  signInWithGoogleSaga,
  // signInWithFacebookSaga,
  passwordResetSaga,
  updatePasswordSaga,
  setPasswordSaga,
  authStateChangedSaga,
  logoutSaga,
  setNamesSaga,
  setLanguageSaga,
  setDarkModeSaga,
  setDisableTasksDoneSaga,
  setDisableAdviceShowSaga,
  setAdviceShowedAtSaga,
  setShowGlobalTasksAsListSaga,
  registerDeviceToken,
  refreshShowGlobalTasksAsListSaga,
  refreshDisableTasksDoneSaga,
  refreshLanguageSaga,
  refreshUserSaga,
} from './auth';

import {
  createTaskSingleSaga,
  createTaskRegularSaga,
  createTaskDelayedSaga,
  createTaskGlobalSaga,
  updateTaskSingleSaga,
  updateTaskRegularSaga,
  updateTaskDelayedSaga,
  updateTaskGlobalSaga,
  removeTaskSingleSaga,
  removeTaskRegularSaga,
  removeTaskDelayedSaga,
  removeTaskGlobalSaga,
  getTasksServerSaga,
  refreshTasksSaga,
} from './tasks';

import { getLabelsSaga, createLabelSaga, updateLabelSaga, removeLabelSaga, refreshLabelsSaga } from './labels';

export function* watchAuth() {
  yield all([
    takeEvery(actionTypes.CREATE_USER, createUserSaga),
    takeEvery(actionTypes.SIGN_IN_WITH_EMAIL, signInWithEmailSaga),
    takeEvery(actionTypes.SIGN_IN_WITH_TOKEN, signInWithTokenSaga),
    takeEvery(actionTypes.SIGN_IN_WITH_GOOGLE, signInWithGoogleSaga),
    // takeEvery(actionTypes.SIGN_IN_WITH_FACEBOOK, signInWithFacebookSaga),
    takeEvery(actionTypes.PASSWORD_RESET, passwordResetSaga),
    takeEvery(actionTypes.UPDATE_PASSWORD, updatePasswordSaga),
    takeEvery(actionTypes.SET_PASSWORD, setPasswordSaga),
    takeEvery(actionTypes.AUTH_STATE_CHANGED, authStateChangedSaga),
    takeEvery(actionTypes.LOGOUT, logoutSaga),
    takeEvery(actionTypes.SET_NAMES, setNamesSaga),
    takeEvery(actionTypes.SET_LANGUAGE, setLanguageSaga),
    takeEvery(actionTypes.SET_DARK_MODE, setDarkModeSaga),
    takeEvery(actionTypes.SET_DISABLE_TASKS_DONE, setDisableTasksDoneSaga),
    takeEvery(actionTypes.SET_DISABLE_ADVICE_SHOW, setDisableAdviceShowSaga),
    takeEvery(actionTypes.SET_ADVICE_SHOWED_AT, setAdviceShowedAtSaga),
    takeEvery(actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST, setShowGlobalTasksAsListSaga),
    takeEvery(actionTypes.REGISTER_DEVICE_TOKEN, registerDeviceToken),
    takeEvery(actionTypes.REFRESH_SHOW_GLOBAL_TASKS_AS_LIST, refreshShowGlobalTasksAsListSaga),
    takeEvery(actionTypes.REFRESH_DISABLE_TASKS_DONE, refreshDisableTasksDoneSaga),
    takeEvery(actionTypes.REFRESH_LANGUAGE, refreshLanguageSaga),
    takeEvery(actionTypes.REFRESH_USER, refreshUserSaga),
  ]);
}

export function* watchTasks() {
  yield all([
    takeEvery(actionTypes.CREATE_TASK_SINGLE, createTaskSingleSaga),
    takeEvery(actionTypes.CREATE_TASK_REGULAR, createTaskRegularSaga),
    takeEvery(actionTypes.CREATE_TASK_DELAYED, createTaskDelayedSaga),
    takeEvery(actionTypes.CREATE_TASK_GLOBAL, createTaskGlobalSaga),
    takeEvery(actionTypes.UPDATE_TASK_SINGLE, updateTaskSingleSaga),
    takeEvery(actionTypes.UPDATE_TASK_REGULAR, updateTaskRegularSaga),
    takeEvery(actionTypes.UPDATE_TASK_DELAYED, updateTaskDelayedSaga),
    takeEvery(actionTypes.UPDATE_TASK_GLOBAL, updateTaskGlobalSaga),
    takeEvery(actionTypes.REMOVE_TASK_SINGLE, removeTaskSingleSaga),
    takeEvery(actionTypes.REMOVE_TASK_REGULAR, removeTaskRegularSaga),
    takeEvery(actionTypes.REMOVE_TASK_DELAYED, removeTaskDelayedSaga),
    takeEvery(actionTypes.REMOVE_TASK_GLOBAL, removeTaskGlobalSaga),
    takeEvery(actionTypes.GET_TASKS_SERVER, getTasksServerSaga),
    takeEvery(actionTypes.REFRESH_TASKS, refreshTasksSaga),
  ]);
}

export function* watchLabels() {
  yield all([
    takeEvery(actionTypes.GET_LABELS, getLabelsSaga),
    takeEvery(actionTypes.CREATE_LABEL, createLabelSaga),
    takeEvery(actionTypes.UPDATE_LABEL, updateLabelSaga),
    takeEvery(actionTypes.REMOVE_LABEL, removeLabelSaga),
    takeEvery(actionTypes.REFRESH_LABELS, refreshLabelsSaga),
  ]);
}
